import React, { useEffect, useState } from "react";
import { kundliApi } from "../../services/api";
import { Table, PageHeader, Pagination, Modal, Badge } from "../../components/ui";

function KundliDetail({ person, onClose }) {
  if (!person) return null;
  const fields = [
    ["ID", person.id], ["User ID", person.userId], ["Full Name", person.fullName],
    ["Gender", person.gender],
    ["Date of Birth", person.dateOfBirth ? new Date(person.dateOfBirth).toLocaleDateString("en-IN") : "—"],
    ["Birth Time", person.birthTime], ["Birth Place", person.birthPlace],
    ["Latitude", person.birthPlaceLatitude], ["Longitude", person.birthPlaceLongitude],
    ["Deleted", person.isDeleted ? "Yes" : "No"],
    ["Created", person.createdAt ? new Date(person.createdAt).toLocaleString("en-IN") : "—"],
    ["Updated", person.updatedAt ? new Date(person.updatedAt).toLocaleString("en-IN") : "—"],
  ];
  return (
    <Modal open={!!person} onClose={onClose} title="Kundli Person Details" width={500}>
      {fields.map(([k,v]) => (
        <div key={k} style={{ display:"flex", justifyContent:"space-between", padding:"8px 0", borderBottom:"1px solid var(--border)" }}>
          <span style={{ fontSize:12, color:"var(--text-muted)", fontWeight:500, textTransform:"uppercase", letterSpacing:"0.5px" }}>{k}</span>
          <span style={{ fontSize:13, color:"var(--text-primary)", textAlign:"right", maxWidth:"60%", wordBreak:"break-all" }}>{v??'—'}</span>
        </div>
      ))}
    </Modal>
  );
}

export default function Kundli() {
  const [data, setData] = useState({ content:[], totalPages:0, totalElements:0 });
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    setLoading(true);
    kundliApi.getAll(page).then(r=>setData(r.data.data)).catch(()=>{}).finally(()=>setLoading(false));
  }, [page]);

  const columns = [
    { key:"createdAt", label:"Created", render:v=>v?new Date(v).toLocaleDateString("en-IN"):"—" },
    { key:"fullName", label:"Name", render:(v,row)=>(
      <div>
        <div style={{ fontWeight:500 }}>{v}</div>
        <div style={{ fontSize:11, color:"var(--text-muted)" }}>{row.gender}</div>
      </div>
    )},
    { key:"userId", label:"User ID", render:v=><span style={{ fontSize:11,fontFamily:"monospace",color:"var(--text-muted)" }}>{v?.slice(-10)}</span> },
    { key:"dateOfBirth", label:"DOB", render:v=>v?new Date(v).toLocaleDateString("en-IN"):"—" },
    { key:"birthTime", label:"Time" },
    { key:"birthPlace", label:"Place", render:v=><span style={{ fontSize:12 }}>{v}</span> },
    { key:"isDeleted", label:"Deleted", render:v=><Badge variant={v?"danger":"success"}>{v?"Yes":"No"}</Badge> },
    { key:"id", label:"", render:(v,row)=>(
      <button onClick={()=>setSelected(row)} style={{ background:"none",border:"none",cursor:"pointer",fontSize:14,color:"var(--teal-400)" }}>View →</button>
    )},
  ];

  return (
    <div>
      <PageHeader title="Kundli Persons" subtitle="All kundli profiles created by users" />
      <div style={{ background:"var(--bg-card)", border:"1px solid var(--border)", borderRadius:"var(--radius-lg)", overflow:"hidden" }}>
        <div style={{ padding:"14px 20px", borderBottom:"1px solid var(--border)", display:"flex", justifyContent:"space-between" }}>
          <span style={{ fontSize:13, color:"var(--text-secondary)" }}>{data.totalElements} persons</span>
          <span style={{ fontSize:12, color:"var(--text-muted)" }}>Page {page+1} of {data.totalPages||1}</span>
        </div>
        {loading ? <div style={{ padding:40, textAlign:"center", color:"var(--text-muted)" }}>Loading…</div>
          : <Table columns={columns} data={data.content} emptyText="No kundli persons" />}
        <div style={{ padding:"0 16px" }}><Pagination page={page} totalPages={data.totalPages} onChange={setPage} /></div>
      </div>
      <KundliDetail person={selected} onClose={()=>setSelected(null)} />
    </div>
  );
}
